import { Component, Input, ViewChild } from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';
import { FullRouteNavItem } from '../../models/nav-item.model';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent {
  @Input({ required: true }) items!: FullRouteNavItem[];
  @ViewChild('childMenu') public childMenu!: MatMenuPanel<MatMenuPanel> | null;
}
